import React from 'react';
import { NoiseOverlay, Navigation, Footer } from './components';
import { PageProvider, usePageContext, ReportProvider, useReportContext } from './contexts';
import { LandingPage, ApplyPage, ManifestoPage, IntelligencePage, NewsPage, ServicesPage, AITransformationPage, AITrainingPage, AdminPage, CampaignPage } from './pages';

// Inner App component that uses context
const AppContent = () => {
  const { currentPage, navigateTo, toggleMenu, isMenuOpen, newsSearchQuery, setNewsSearchQuery } = usePageContext();
  const { viewReport, currentReport } = useReportContext();

  const handleViewReport = (report) => {
    viewReport(report);
    navigateTo('intelligence');
  };

  return (
    <div className="font-sans antialiased text-zinc-900 bg-zinc-50 overflow-x-hidden selection:bg-orange-500 selection:text-white">
      <NoiseOverlay />

      {currentPage !== 'ai-transformation' && currentPage !== 'ai-training' && currentPage !== 'admin' && currentPage !== 'campaign' && (
        <Navigation
          navigateTo={navigateTo}
          activePage={currentPage}
          newsSearchQuery={newsSearchQuery}
          setNewsSearchQuery={setNewsSearchQuery}
          toggleMenu={toggleMenu}
          isMenuOpen={isMenuOpen}
        />
      )}

      <main>
        {currentPage === 'landing' ? (
          <LandingPage />
        ) : currentPage === 'manifesto' ? (
          <ManifestoPage />
        ) : currentPage === 'intelligence' ? (
          <IntelligencePage />
        ) : currentPage === 'news' ? (
          <NewsPage />
        ) : currentPage === 'services' ? (
          <ServicesPage />
        ) : currentPage === 'ai-transformation' ? (
          <AITransformationPage />
        ) : currentPage === 'ai-training' ? (
          <AITrainingPage />
        ) : currentPage === 'admin' ? (
          <AdminPage />
        ) : currentPage === 'campaign' ? (
          <CampaignPage />
        ) : (
          <ApplyPage />
        )}
      </main>

      {currentPage !== 'admin' && currentPage !== 'campaign' && <Footer />}
    </div>
  );
};

// Main App component with providers
export default function App() {
  return (
    <PageProvider>
      <ReportProvider>
        <AppContent />
      </ReportProvider>
    </PageProvider>
  );
}
